import Vue from 'vue';
import axios from 'axios';
import msal from 'vue-msal';
import vuetify from './plugins/vuetify';
import App from './App.vue';
import router from './router';
/*
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

const appInsights = new ApplicationInsights({ config: {
  instrumentationKey: process.env.VUE_APP_INSIGHTS_INSTRUMENTATION_KEY
} });
appInsights.loadAppInsights();
appInsights.trackPageView();
*/
Vue.config.productionTip = false;

// Setup axios as the Vue default $http library
Vue.prototype.$http = axios;
Vue.prototype.$http.defaults.baseURL = process.env.VUE_APP_API_URL;

Vue.prototype.$http.interceptors.request.use(config => {
  let token = sessionStorage.getItem("msal.idtoken");
  config.headers = Object.assign({
    Authorization: `Bearer ${token}`
  }, config.headers);
  return config;
});

Vue.prototype.$http.interceptors.response.use(
  response => response,
  error => {
      const {status} = error.response;
      if (status === 401) {
        console.error(error); /* eslint-disable-line no-console */
        if (error && error.config && error.config.url && error.config.url.startsWith(process.env.VUE_APP_API_URL)) {
          sessionStorage.clear();
          window.location.reload(true);
        }
      }
      return Promise.reject(error);
 }
);

Vue.use(msal, {
  auth: {
    clientId: process.env.VUE_APP_AUTH_CLIENTID,
    tenantId: process.env.VUE_APP_AUTH_TENANTID,
    redirectUri: process.env.VUE_APP_APP_URL,
    navigateToLoginRequestUrl: false,
    requireAuthOnInitialize : true
  },
  graph: {
    callAfterInit: true,
    endpoints: {
      profile: '/me',
      photo: {
        url: '/me/photo/$value',
        responseType: 'blob',
        force: true
      }
    }
  },
  cache: {
    cacheLocation: "sessionStorage"
  }
});

const moment = require('moment');
require('moment/locale/nl');

Vue.use(require('vue-moment'), {
  moment
});

console.debug('version:' + process.env.VUE_APP_VERSION); /* eslint-disable-line no-console */
Vue.prototype.$version = process.env.VUE_APP_VERSION;
console.debug('locale: ' + Vue.moment().locale()); /* eslint-disable-line no-console */

/* eslint-disable no-new */
new Vue({
  vuetify,
  router,
  axios,
  render: h => h(App)
}).$mount('#app');